import { render, staticRenderFns } from "./nested-nodes.vue?vue&type=template&id=84a37dd2&scoped=true"
import script from "./nested-nodes.vue?vue&type=script&lang=js"
export * from "./nested-nodes.vue?vue&type=script&lang=js"
import style0 from "./nested-nodes.vue?vue&type=style&index=0&id=84a37dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a37dd2",
  null
  
)

export default component.exports